import React from 'react';

import { ReactComponent as AdminIcon } from './admin.svg';
import { ReactComponent as DashboardIcon } from './dashboard.svg';
import { ReactComponent as FinanceIcon } from './finance.svg';
import { ReactComponent as NotificationIcon } from './notification.svg';
import { ReactComponent as ProjectIcon } from './project.svg';
import { ReactComponent as PromotionIcon } from './promotion.svg';
import { ReactComponent as TeamIcon } from './team.svg';

const InvestmentsIcon = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3v18h18" />
    <path d="M19 9l-5 5-4-4-4 4" />
  </svg>
);

const AccrualsIcon = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" />
    <path d="M12 8v8M8 12h8" />
  </svg>
);

const sidebarIcons = {
  admin: AdminIcon,
  dashboard: DashboardIcon,
  finance: FinanceIcon,
  notification: NotificationIcon,
  project: ProjectIcon,
  team: TeamIcon,
  promotion: PromotionIcon,
  investments: InvestmentsIcon,
  accruals: AccrualsIcon,
};

export default sidebarIcons;
